import React, { useEffect } from "react";
import styles from "./styles.module.scss";

export default ({ scrollTo }) => {
    useEffect(() => {
        if (scrollTo) {
            const cookiePolicy = document.getElementsByClassName(scrollTo)[0];
            cookiePolicy.scrollIntoView();
        }
    }, [scrollTo]);

    return (
        <div className={styles.terms}>
            <div className={`${styles.document} ${styles.korean}`}>
                <h1>서비스 이용약관 (개정본)</h1>

                <div className={styles.section}>
                    <h2 className={styles.subSectionTitle}>제1장 총칙</h2>
                </div>

                <div className={styles.section}>
                    <h2>제1장 총칙</h2>
                    <p>
                        이 약관은 주식회사 한국증권대차(구
                        트루테크놀로지스)(이하 “회사”)가 제공하는 대차거래 관련
                        자동화 시스템 및 정보제공 서비스(이하 “서비스”)의 이용과
                        관련하여 회사와 이용자 간의 권리, 의무 및 책임사항 기타
                        필요한 사항을 규정함을 목적으로 합니다.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>제2조(정의) 용어의 정의</h2>
                    <ul>
                        <li>
                            1. 이 약관에서 사용하는 용어의 정의는 다음과
                            같습니다.
                            <ul>
                                <li>
                                    1.1 “서비스”라 함은 회사가 제공하는 자동화
                                    시스템, API, 데이터 전달, 알림, 정보제공
                                    기능 및 기타 관련 서비스 일체를 의미합니다.
                                </li>
                                <li>
                                    1.2 “이용자”라 함은 회사가 제공하는 서비스를
                                    이용하는 회원 및 비회원을 말합니다.
                                </li>
                                <li>
                                    1.3 “회원”이라 함은 회사와 이용계약을
                                    체결하고 아이디(ID)를 부여받아 서비스를
                                    이용하는 자를 말합니다.
                                </li>
                                <li>
                                    1.4 “아이디(ID)”라 함은 회원의 식별 및
                                    서비스 이용을 위하여 회사가 승인하는 문자,
                                    숫자 또는 이메일 주소를 의미합니다.
                                </li>
                                <li>
                                    1.5 “비밀번호(PASSWORD)”라 함은 회원 본인
                                    확인 및 보안 유지를 위하여 회원이 설정한
                                    문자 및 숫자의 조합을 의미합니다.
                                </li>
                                <li>
                                    1.6 “이용계약”이라 함은 회사와 이용자 또는
                                    기관 간에 체결되는 서비스 이용 계약을
                                    의미합니다.
                                </li>
                                <li>
                                    1.7 “계정정보”라 함은 이용기관, 부서,
                                    식별코드 및 기타 서비스 이용과 관련된 정보를
                                    의미합니다.
                                </li>
                                <li>
                                    1.8 “고객입력정보”라 함은 이용자가 서비스
                                    이용 과정에서 입력 또는 제공하는 정보 일체를
                                    의미합니다.
                                </li>
                                <li>
                                    1.9 “유료서비스”라 함은 회사가 별도의
                                    이용대가를 받고 제공하는 서비스 일체를
                                    의미합니다.
                                </li>
                            </ul>
                        </li>
                        <li>
                            2. 본 약관에서 정의되지 아니한 용어는 관련 법령 및
                            일반 상관례에 따릅니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제3조 (약관의 효력, 명시 및 개정)</h2>
                    <ul>
                        <li>
                            3.1 회사는 본 약관의 내용을 서비스 화면 또는
                            홈페이지 등을 통해 공지합니다.
                        </li>
                        <li>
                            3.2 회사는 관련 법령을 위반하지 않는 범위에서 본
                            약관을 개정할 수 있습니다.
                        </li>
                        <li>
                            3.3 개정 약관은 시행일 7일 전부터 공지하며, 이용자가
                            시행일 전까지 이의를 제기하지 아니한 경우 개정
                            약관에 동의한 것으로 봅니다.
                        </li>
                        <li>3.4 본 약관은 2026년 6월 15일부터 시행됩니다.</li>
                        <li>
                            3.5 회사의 혁신금융서비스 지정은 금융위원회의
                            투자중개업 예비인가 신청에 대한 최종 결정에 따라
                            종료될 예정이며, 해당 결정은 2026년 6월 15일 또는 그
                            이후 이루어질 수 있습니다. 이후 회사는 관련 법령 및
                            금융당국의 유권해석 등에 따라 허용되는 범위 내에서만
                            서비스를 제공할 수 있습니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제4조 (약관의 해석)</h2>
                    <ul>
                        <li>
                            4.1 회사와 이용자 또는 기관 간 별도의 계약이 체결된
                            경우 해당 계약이 우선 적용됩니다.
                        </li>
                        <li>
                            4.2 본 약관에서 정하지 아니한 사항은 관련 법령 및
                            일반 상관례에 따릅니다.
                        </li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2 className={styles.subSectionTitle}>
                        제2장 서비스 이용계약
                    </h2>
                </div>

                <div className={styles.section}>
                    <h2>제5조 (이용계약의 성립)</h2>
                    <ul>
                        <li>
                            5.1 회사가 제공하는 서비스는 자동화 시스템, 데이터
                            전달, 정보제공 및 업무 효율화 지원을 위한
                            기술입니다.
                        </li>
                        <li>
                            5.2 회사는 대차거래의 당사자가 아니며, 이용자 간
                            거래를 중개, 주선, 대리하지 않습니다.
                        </li>
                        <li>
                            5.3 회사의 서비스는 단순한 정보의 제공, 전달 및
                            기술적 지원 기능 제공에 한정됩니다.
                        </li>
                        <li>
                            5.4 서비스 제공 사실 자체가 회사가 특정 인허가를
                            보유하고 있거나 특정 규제상 지위를 유지함을 의미하지
                            않습니다.
                        </li>
                        <li>
                            5.5 이용자는 스스로 관련 법령, 내부통제기준 및
                            규제상 제한사항을 검토하여 서비스 이용 가능 여부를
                            판단하여야 하며, 회사는 이용자의 규제 적합성 여부에
                            관하여 어떠한 책임도 부담하지 않습니다.
                        </li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2>제6조 (이용신청의 승인)</h2>
                    <p>
                        회사는 기관이 회사와 이용계약을 체결한 경우, 그 이용자의
                        신청에 대하여 회원가입을 승낙함을 원칙으로 합니다. 다만,
                        회사는 다음 각 항에 해당하는 신청에 대하여는 승낙을 하지
                        않거나 사후에 이용계약을 해지할 수 있습니다.
                    </p>
                    <ul>
                        <li>
                            6.1 회사는 운영상, 기술상 또는 규제상 필요에 따라
                            서비스의 전부 또는 일부를 변경 또는 종료할 수
                            있습니다.
                        </li>
                        <li>
                            6.2 회사는 혁신금융서비스 종료 이후 기존 서비스를
                            종료하거나, 관련 법령 및 금융당국의 유권해석 등에
                            따라 허용되는 제한적인 범위 내에서만 서비스를 제공할
                            수 있습니다.
                        </li>
                        <li>
                            6.3 회사는 서비스 변경 또는 종료 시 사전 또는 사후
                            공지를 할 수 있습니다.
                        </li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2>제7조 (이용신청의 제한)</h2>
                    <p>
                        회사는 서비스 관련 설비의 여유가 없거나, 기술상 또는
                        업무상 문제가 있는 경우에는 승낙을 유보할 수 있습니다.
                    </p>
                    <ul>
                        <li>
                            7.1 이용자는 관련 법령 및 본 약관을 준수하여야
                            합니다.
                        </li>
                        <li>
                            7.2 이용자는 서비스를 이용함에 있어 다음 각 호의
                            행위를 하여서는 아니 됩니다. ① 허위 정보 입력 ②
                            타인의 정보 도용 ③ 회사 시스템에 대한 해킹, 역설계,
                            크롤링 또는 비정상적 접근 ④ 회사의 승인 없는 데이터
                            저장, 복제, 재판매 또는 상업적 활용 ⑤ 회사 또는
                            제3자의 권리 침해 ⑥ 법령 위반 행위
                        </li>
                        <li>
                            7.3 이용자는 회사의 시스템, 프로그램, 데이터, API 및
                            관련 정보 등을 제3자에게 무단 제공하거나
                            유출하여서는 아니 됩니다.
                        </li>
                        <li>
                            7.4 이용자는 API 또는 시스템 연동을 통하여 전달되는
                            데이터의 정확성, 적법성 및 사용 가능 여부를 스스로
                            검증하여야 합니다.
                        </li>
                    </ul>
                </div>

                <div className={styles.section}>
                    <h2>제8조 (이용자 정보의 제공)</h2>
                    <ul>
                        <li>
                            8.1 회사가 제공하는 데이터, 정보 및 분석자료는 단순
                            정보제공 목적이며 투자자문, 투자권유, 금융상품 매매
                            권유 또는 법률·회계 자문에 해당하지 않습니다.
                        </li>
                        <li>
                            8.2 이용자는 자신의 판단과 책임 하에 서비스를
                            이용하여야 하며, 회사는 이용자의 투자판단 또는 거래
                            결과에 대하여 책임을 부담하지 않습니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제9조 (회원정보의 변경)</h2>
                    <ul>
                        <li>
                            9.1 회사는 천재지변, 전산장애, 통신장애, 클라우드
                            서비스 장애, 제3자 시스템 장애 또는 기타 불가항력
                            사유로 인한 손해에 대하여 책임을 지지 않습니다.
                        </li>
                        <li>
                            9.2 회사는 이용자 상호 간 또는 이용자와 제3자
                            사이에서 발생한 분쟁에 관여하지 않으며 이에 대한
                            책임을 부담하지 않습니다.
                        </li>
                        <li>
                            9.3 회사는 이용자가 제공한 정보의 오류, 누락 또는
                            부정확성으로 인한 손해에 대하여 책임을 부담하지
                            않습니다.
                        </li>
                        <li>
                            9.4 회사는 이용자가 서비스를 통하여 전달받은 정보
                            또는 데이터를 이용하여 수행한 거래 또는 의사결정에
                            대하여 책임을 부담하지 않습니다.
                        </li>
                        <li>
                            9.5 회사는 이용자가 관련 법령상 허용되지 않는
                            방식으로 서비스를 이용함으로써 발생하는 문제에
                            대하여 책임을 부담하지 않습니다.
                        </li>
                        <li>
                            9.6 회사는 서비스 이용 가능 여부, 규제 적합성 여부
                            또는 인허가 필요 여부에 관하여 어떠한 보증도 하지
                            않습니다.
                        </li>
                        <li>
                            9.7 회사는 이용자에 대하여 신인의무(fiduciary duty),
                            투자자 보호의무 또는 자문인으로서의 의무를 부담하지
                            않습니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>
                        제10조 (회원의 아이디 및 비밀번호의 관리에 대한 의무)
                    </h2>
                    <ul>
                        <li>
                            10.1 이용자가 본 약관 또는 관련 법령을 위반함으로
                            인하여 회사에 손해가 발생한 경우 이용자는 회사에
                            대한 모든 손해를 배상하여야 합니다.
                        </li>
                        <li>
                            10.2 이용자는 자신의 서비스 이용과 관련하여 제3자가
                            회사에 대하여 제기하는 모든 청구, 손해, 비용 및
                            책임으로부터 회사를 면책하고 방어하여야 합니다.
                        </li>
                        <li>
                            10.3 회사의 손해배상 책임은 회사의 고의 또는 중대한
                            과실이 있는 경우에 한하여 인정됩니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제11조 (회원에 대한 통지)</h2>
                    <ul>
                        <li>
                            11.1 서비스, 시스템, 데이터, API, 화면 구성,
                            소프트웨어 및 관련 자료에 대한 모든 지적재산권은
                            회사에 귀속됩니다.
                        </li>
                        <li>
                            11.2 이용자는 회사의 사전 서면 동의 없이 이를 복제,
                            배포, 수정, 역설계, 재판매 또는 상업적으로 이용할 수
                            없습니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제12조 (회원탈퇴 및 자격 상실)</h2>
                    <ul>
                        <li>12.1 본 약관은 대한민국 법률에 따라 해석됩니다.</li>
                        <li>
                            12.2 본 약관과 관련하여 발생하는 분쟁은 대한민국
                            법원을 전속 관할법원으로 합니다.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>제33조 (회사의 연락처)</h2>
                    <p>
                        회사의 상호 및 주소 등은 다음과 같습니다.
                        <br />
                        상호: 주식회사 트루테크놀로지스
                        <br />
                        주소: 서울특별시 영등포구 의사당대로 83 (여의도동)
                        <br />
                        대표 이사: 하재우
                        <br />
                        이메일 주소:{" "}
                        <a href="mailto:support@kslnetwork.com">
                            support@kslnetwork.com
                        </a>
                        <br />
                        사업자등록번호: 502-88-01347
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>부칙</h2>본 약관은 2026년 6월 15일부터 시행합니다.
                </div>
                <div className={styles.section}>
                    <p>시행일자 : 2026. 6. 15</p>
                </div>
            </div>

            <div className={styles.document}>
                <h1>TERMS OF USE</h1>
                <div className={styles.section}>
                    <h2>1. General</h2>
                    <ul>
                        <li>
                            1.1 Purpose
                            <p>
                                These Terms govern the use of the automation
                                systems, APIs, information delivery functions
                                and related services (“Services”) provided by
                                Korea Securities Lending Co., Ltd. (“KSL” or
                                “Company”).
                            </p>
                        </li>
                        <li>
                            1.2 Nature of Services
                            <p>
                                The Services are limited to technological
                                automation tools, information delivery and data
                                management functions.
                            </p>
                            <p>KSL:</p>
                            <ul>
                                <li>
                                    is not a broker, intermediary or agent in
                                    relation to securities lending transactions;
                                    and
                                </li>
                                <li>
                                    merely provides technical infrastructure,
                                    automated technological functions and
                                    passive information transmission functions.
                                </li>
                            </ul>
                            <p>
                                The Services do not constitute and should not be
                                interpreted as:
                            </p>
                            <ul>
                                <li>investment advice;</li>
                                <li>investment solicitation;</li>
                                <li>securities brokerage;</li>
                                <li>transaction intermediation; or</li>
                                <li>regulated financial services.</li>
                            </ul>
                        </li>
                        <li>
                            1.3 Regulatory Status
                            <p>
                                KSL’s designation as an innovative financial
                                service provider under Korean law is expected to
                                terminate upon the Financial Services
                                Commission’s final determination regarding KSL’s
                                preliminary brokerage license application,
                                expected on or after 15 June 2026. Thereafter,
                                KSL may provide services only within the scope
                                permitted under applicable laws, regulations,
                                and regulatory interpretations.
                            </p>
                            <p>Following such termination:</p>
                            <ul>
                                <li>
                                    the existing innovative financial services
                                    will be discontinued; and
                                </li>
                                <li>
                                    any services provided thereafter shall
                                    constitute separate and newly structured
                                    services provided only to the extent
                                    permitted under applicable laws, regulations
                                    and regulatory interpretations.
                                </li>
                            </ul>
                            <p>
                                The provision of the Services does not represent
                                or guarantee that:
                            </p>
                            <ul>
                                <li>
                                    KSL holds any specific license or regulatory
                                    approval;
                                </li>
                                <li>
                                    the Services are permitted for all users
                                    under applicable laws; or
                                </li>
                                <li>
                                    users are legally permitted to use the
                                    Services.
                                </li>
                            </ul>
                            <p>
                                Users are solely responsible for independently
                                determining whether they are legally permitted
                                to access or use the Services under applicable
                                laws, regulations, internal policies and
                                compliance requirements.
                            </p>
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>2. Availability and Modification of Services</h2>
                    <p>
                        KSL may modify, suspend or terminate all or part of the
                        Services at any time for operational, technical, legal
                        or regulatory reasons.
                    </p>
                    <p>
                        KSL will discontinue the innovative financial services
                        upon termination of the innovative financial services
                        designation.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>3. User Obligations</h2>
                    <p>Users shall:</p>
                    <ul>
                        <li>comply with applicable laws and regulations;</li>
                        <li>
                            refrain from unauthorized copying, redistribution or
                            commercial exploitation of the Services or data;
                        </li>
                        <li>
                            not reverse engineer, scrape, hack or interfere with
                            the Services;
                        </li>
                        <li>not misuse the Services for unlawful purposes.</li>
                    </ul>
                    <p>
                        Users shall not disclose account credentials, APIs,
                        system structures or confidential information to third
                        parties.
                    </p>
                    <p>
                        Users are responsible for independently verifying the
                        accuracy, legality and usability of any data transmitted
                        through APIs or system integrations.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>4. No Brokerage / No Transaction Responsibility</h2>
                    <p>
                        KSL does not act as a broker, arranger, intermediary or
                        agent in relation to any transaction.
                    </p>
                    <p>
                        Any securities lending transaction, collateral transfer,
                        settlement, recall, lifecycle event or related legal
                        obligation remains solely between the relevant users
                        and/or regulated financial institutions.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>5. Disclaimer</h2>
                    <p>
                        The Services, data and content are provided on an “AS
                        IS” basis.
                    </p>
                    <p>KSL makes no representation or warranty regarding:</p>
                    <ul>
                        <li>legality of use;</li>
                        <li>regulatory suitability;</li>
                        <li>uninterrupted operation;</li>
                        <li>accuracy or completeness of data; or</li>
                        <li>fitness for a particular purpose.</li>
                    </ul>
                    <p>KSL shall not be liable for:</p>
                    <ul>
                        <li>trading losses;</li>
                        <li>regulatory violations by users;</li>
                        <li>system interruption;</li>
                        <li>cloud or telecommunications failures;</li>
                        <li>third-party system failures;</li>
                        <li>errors or omissions in user-provided data;</li>
                        <li>business interruption;</li>
                        <li>indirect or consequential damages.</li>
                    </ul>
                    <p>
                        KSL does not owe any fiduciary duty, advisory duty or
                        investor protection obligation to users.
                    </p>
                    <p>
                        Users access and use the Services at their own risk and
                        discretion.
                    </p>
                </div>
                <div className={styles.section}>
                    <h2>6. Indemnity</h2>
                    <p>
                        Users shall indemnify, defend and hold harmless KSL and
                        its affiliates, officers, employees and agents from and
                        against any claims, losses, liabilities, damages, costs
                        and expenses arising out of:
                    </p>
                    <ul>
                        <li>the user’s breach of these Terms;</li>
                        <li>unlawful use of the Services;</li>
                        <li>violation of applicable laws;</li>
                        <li>disputes between users or third parties.</li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>7. Intellectual Property</h2>
                    <p>
                        All intellectual property rights relating to the
                        Services, APIs, systems, software, data, documentation
                        and workflows belong exclusively to KSL.
                    </p>
                    <p>Users may not:</p>
                    <ul>
                        <li>copy;</li>
                        <li>redistribute;</li>
                        <li>reverse engineer;</li>
                        <li>commercially exploit; or</li>
                        <li>
                            create derivative works,
                            <br />
                            without KSL’s prior written consent.
                        </li>
                    </ul>
                </div>
                <div className={styles.section}>
                    <h2>8. Governing Law</h2>
                    <p>
                        These Terms shall be governed by the laws of the
                        Republic of Korea.
                    </p>
                    <p>
                        Any dispute arising from these Terms shall be subject to
                        the exclusive jurisdiction of the courts of the Republic
                        of Korea.
                    </p>
                </div>
                <div className={styles.section}>
                    <p>
                        Effective Date: These Terms become effective on 15 June
                        2026.
                    </p>
                </div>
            </div>
        </div>
    );
};
